/* eslint-disable */
const {KitModule, registerModule} = window;

import Swiper from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

class Carousel extends KitModule {
  constructor($element) {
    super($element);
    this.settings = this.$element.dataset.settings ? JSON.parse(this.$element.dataset.settings) : {};

    this.params = {
      modules: [A11y, Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
          600: {
              slidesPerView: 2
          },
          960: {
              slidesPerView: 2
          },
          1280: {
              slidesPerView: 4.5
          },
          1440: {
              slidesPerView: 4.5
          }
      },
      grabCursor: true,
      // pagination: {
      //   clickable: true,
      //   el: '.pagination__list',
      //   renderBullet: function (index, className) {
      //     return `<button class="pagination__list-number type-eyebrow-3 ${className}">${index + 1}</button>`;
      //   }
      // },
      navigation: {
        nextEl: ".next",
        prevEl: ".previous",
      }
    };

    const swiperEl = `#${this.$element.id}`;
    const swiperOptions = {...this.params, ...this.settings};
    const swiper = new Swiper(swiperEl, swiperOptions);
  }
}

registerModule('Carousel', Carousel);
